import React, { useState } from "react";
import { cx } from "./format";

const initials = (name = "") =>
  String(name)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase() || "?";

/** Photo when there is one, otherwise gold initials. */
export const Avatar = ({ name, src, size = 32, className, tone = "gold" }) => {
  const [broken, setBroken] = useState(false);
  const toneCls = tone === "red" ? "bg-cm-red text-white" : "bg-cm-gold-soft text-cm-gold-text";
  return src && !broken ? (
    <img
      src={src}
      alt={name || ""}
      onError={() => setBroken(true)}
      className={cx("rounded-full object-cover shrink-0 bg-cm-surface-2", className)}
      style={{ width: size, height: size }}
    />
  ) : (
    <span
      aria-hidden={name ? undefined : true}
      className={cx("rounded-full grid place-items-center font-bold shrink-0", toneCls, className)}
      style={{ width: size, height: size, fontSize: Math.max(10, size * 0.38) }}
    >
      {initials(name)}
    </span>
  );
};

/** Avatar + name + secondary line, for table cells and lists. */
export const PersonCell = ({ name, sub, src, size = 32 }) => (
  <div className="flex items-center gap-2.5 min-w-0">
    <Avatar name={name} src={src} size={size} />
    <div className="min-w-0">
      <div className="text-sm font-medium text-cm-text truncate">{name || "—"}</div>
      {sub && <div className="text-xs text-cm-muted truncate">{sub}</div>}
    </div>
  </div>
);

export default Avatar;
